module.exports = __webpack_public_path__ + "static/img/10.b2f9fd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/10.png
// module id = JlGt
// module chunks = 0